import "./EgamingStats.css";

function EgamingStats() {
  return <div className="stats-page"></div>;
}

export default EgamingStats;
